var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("h1", [_vm._v("儿童个人信息保护政策")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "深圳埃努码信息技术有限公司（即本应用在应用市场的开发者/发布者，以下简称“深圳埃努码”）与 北京埃努码信息技术有限公司（以下合称“我们”或“埃努码”）深知儿童个人信息和隐私安全的重要性。我们将按法律法规要求，采取相应安全保护措施，尽力保护儿童的个人信息安全可控。基于此，我们制定本政策。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "本政策是专门针对不满 14 周岁未成年人（以下简称“儿童”）个人信息保护制定的独立规则，本政策主要向法定监护人或儿童的父母（以下简称“监护人”）说明我们如何收集、使用和处理儿童个人信息，所收集儿童个人信息的用途、以及如何管理和保护儿童信息的方式，并申明了我们对保护儿童个人隐私的承诺。我们未来可能根据信息处理情境的变化更新或修改本政策。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "除另有约定，本政策中所用术语和缩略词与《软件许可及服务协议》、《用户个人信息保护政策》中的术语和缩略词具有相同的涵义。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("儿童监护人特别说明：")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "如果您是儿童用户的监护人，请您仔细阅读和选择是否同意本政策。在处理不满 14 周岁未成年人个人信息前，我们将通过显著方式告知并征得监护人的“单独同意”。我们希望请您与我们共同保护儿童的个人信息，教育引导儿童增强个人信息保护意识和能力，指导、提醒和要求他们在未经您同意的情况下，不向任何网络产品和服务提供者提供任何个人信息。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "如果您不同意本政策的内容，将导致我们的产品及服务无法正常运行或无法达到预定的服务效果，您应要求您的孩子立即停止访问/使用都都产品/服务。当您勾选同意本政策或通过弹窗点击确认时，即表示您已给予我们处理您监护儿童信息的明示授权。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("儿童特别说明：")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "本规则的告知对象为监护人，应由儿童的监护人阅读并同意本规则的内容。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "如果您是未满14周岁的儿童，请您务必通知您的监护人仔细阅读本规则，并在征得您的监护人同意后，使用我们的服务或向我们提供个人信息。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "本政策适用于埃努码公司提供服务的所有产品及服务，包括且不仅限于："
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "应用程序：都都数学, 都都英语，都都思维，都都GO，都都Kids，都都one，都都家长服务，都都服务；"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("网站：enuma.cn, todomath.cn, todokids.cn, todoone.cn;"),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("我们将恪守以下原则，保护儿童的个人信息："),
        _c("b", [
          _vm._v(
            "权责一致原则、目的明确原则、选择同意原则、最少够用原则、最小必要原则（即不得收集与所提供的教育服务无关的额外信息）、公开透明原则、确保安全原则、主体参与原则等"
          ),
        ]),
        _vm._v(
          "。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护儿童的个人信息。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "当儿童使用任何我们的服务前，请监护人和儿童务必仔细阅读并透彻理解本规则，在确认充分理解并同意全部条款后再开始使用。一旦您开始使用我们提供的产品或服务，即表示您已充分理解并同意本政策。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "如本政策与《软件许可及服务协议》、《个人信息保护政策》的同类条款之约定存在不一致的，以本政策为准。未尽事宜以《个人信息保护政策》为准。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "我们提醒您，本声明中与您和您监护的儿童的权益（可能）密切相关的重要条款，我们已采用"
        ),
        _c("b", [_vm._v("加粗字体")]),
        _vm._v("来特别提醒您，请您重点查阅。"),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "如您对本政策内容有任何疑问、意见或建议，请通过文末的方式与我们联系。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("本政策将帮助您了解以下内容：")]),
      _vm._v(" "),
      _c("p", [_vm._v("一、我们如何使用和收集儿童个人信息")]),
      _vm._v(" "),
      _c("p", [_vm._v("二、我们如何使用 Cookie 和同类技术")]),
      _vm._v(" "),
      _c("p", [_vm._v("三、我们如何共享、转让、公开披露儿童的个人信息")]),
      _vm._v(" "),
      _c("p", [_vm._v("四、我们如何保护和保存儿童的个人信息")]),
      _vm._v(" "),
      _c("p", [_vm._v("五、监护人和儿童的权利")]),
      _vm._v(" "),
      _c("p", [_vm._v("六、我们如何存储儿童的个人信息")]),
      _vm._v(" "),
      _c("p", [_vm._v("七、本隐私政策如何更新")]),
      _vm._v(" "),
      _c("p", [_vm._v("八、争议解决")]),
      _vm._v(" "),
      _c("p", [_vm._v("九、如何联系我们")]),
      _vm._v(" "),
      _c("p", { staticClass: "align-right" }, [
        _vm._v("本版发布日期：2026 年【09】月【09】日"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "align-right" }, [
        _vm._v("生效日期：2026 年【09】月【09】日"),
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("一、我们如何使用和收集儿童的个人信息")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "我们深知儿童敏感个人信息（如电话号码、设备标识符、精确位置、语音声纹等）一旦泄露或被滥用，可能导致儿童及其监护人的人格尊严受损或人身、财产权益受到侵害。因此，我们严格遵循"
        ),
        _c("b", [_vm._v("最小必要")]),
        _vm._v("和"),
        _c("b", [_vm._v("单独告知")]),
        _vm._v("原则，仅在实现核心功能和服务安全所必需的情况下处理此类信息。"),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "我们会出于本政策所述的以下目的，在征得监护人同意后，收集和使用以下类型的儿童个人信息："
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("1. 成为我们产品的用户")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("注册成为都都产品的用户，儿童的监护人需要提供"),
        _c("b", [_c("i", [_vm._v("电话号码")])]),
        _vm._v(
          "作为基本注册或登录信息，如拒绝提供手机号信息将无法成为都都产品的用户并使用都都的服务。同时监护人可以自行选择填写"
        ),
        _c("i", [
          _vm._v("昵称或代号、填写非真实的孩子出生年月、使用的难度等级"),
        ]),
        _vm._v(
          "等基本信息，创建使用者的学习存档。如您未填写此类信息，将无法完成档案创建，影响您正常使用我们产品中的其他功能。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("2. 提供产品或服务")]),
      _vm._v(" "),
      _c("p", [_vm._v("（1）用户体验改进计划")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "当您使用都都应用程序过程中，为保障您正常使用我们的服务，维护我们服务的正常运行，改进及优化我们的服务体验以及保障您的账号安全，我们会收集您的"
        ),
        _c("b", [_c("i", [_vm._v("设备类型")])]),
        _vm._v(
          "，这类信息是为提供服务必须收集的基础信息。随着都都产品的后续版本升级，我们统计的范围会有所改变，若产品版本升级涉及个人信息处理目的、方式、范围的改变，我们将重新通过弹窗等显著方式征得监护人的明示同意。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("（2）开展营销活动")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "当儿童选择参加我们举办的有关营销活动时，根据活动需要可能使用到"
        ),
        _c("b", [
          _vm._v(
            "儿童个人信息（收货人电话号码、收货地址、儿童昵称或代号）与第三方支付服务账号"
          ),
        ]),
        _vm._v(
          "。这些信息是儿童收到礼品所必要的，我们仅向物流配送必需的第三方提供最少够用的信息，以完成礼品寄送。如果儿童拒绝提供这些信息，我们将可能无法向您提供奖品或发放礼品。 儿童在参加营销活动之前，需确保已经取得监护人的授权同意。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "我们仅通过短信、微信客服、第三方公众平台或邮件提供营销服务，APP内无定向广告或推送。如果您不想接收这些营销服务，可以发邮件至215032956@qq.com或回复短信“退订”申请取消。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("（3）客服与售后")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("我们的客服和售后功能会使用儿童的账号信息为您提供咨询服务。"),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("当监护人和儿童与我们联系时，我们可能会保存"),
        _c("b", [_vm._v("儿童的通信或通话记录和内容或儿童留下的联系方式")]),
        _vm._v(
          "，以便帮助儿童或监护人解决问题，或记录相关问题的处理方案及结果。我们的客服会使用儿童的账号信息与儿童核验身份。监护人和儿童有可能会在与我们的客服人员沟通时，提供给出上述信息外的其他信息。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("（4）语音测评")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "在都都的部分产品中，我们设置了自动化技术的语音评测功能，儿童可以开放设备麦克风权限来进行语音输入（口语跟读、语音评测等）。当您使用该功能时，需要上传语音来判断当前"
        ),
        _c("b", [_c("i", [_vm._v("语言")])]),
        _vm._v(
          "表达等能力。此语音信息在使用完毕后立即删除，不做任何存储。如您不提供此类信息，我们可能无法为您完成语音评测的服务。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("（5）基础业务功能和附加业务功能")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "查看和编辑使用者资料：监护人和儿童可以在都都产品内查看使用者资料，包括"
        ),
        _c("b", [_vm._v("使用者昵称或代号")]),
        _vm._v("信息，您可以选择是否更改使用者资料。"),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "学习或使用数据：在都都产品的内容学习过程中，我们会记录您的使用时间，学习产生的产品数据等。您可以在设置内关闭数据的收集，如您不提供此类信息，我们将无法为您提供学习进度查询、学习报告服务。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("3. 提供安全保护保障")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("儿童的网络身份标识信息帮助儿童维护软件正常使用及使用安全。"),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("b", [
          _vm._v(
            "敏感权限如麦克风不会默认开启，我们将通过弹出窗口询问监护人和儿童是否可以获取相应权限，只有监护人和儿童选择同意后，我们才会为您开启相应权限并接受儿童的个人信息。"
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "儿童可以开放设备麦克风权限来进行语音输入，在此过程中我们使用儿童的语音内容，并对使用数据进行必要的处理以满足儿童的软件使用需求。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "我们会根据儿童在软件安装及使用中授予的具体权限，接收并记录儿童的个人常用设备信息：例如 操作日志、操作系统版本、设备型号、设备所在位置的相关信息（IP地址），使用语言、APP崩溃记录、通过麦克风输入的内容（此字段采集不存储）。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "我们可能会收集、使用或整合使用者账户信息、交易信息、设备信息、日志信息以及我们取得授权或依据法律共享的信息，来综合判断使用者账户及交易风险，进行儿童或监护人的身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "儿童个人信息匿名化处理：在存储和传输儿童个人信息时，我们将采取加密等安全措施，确保信息的保密性与完整性。我们将通过技术手段及时对用户提交的儿童信息数据进行脱敏处理。脱敏后的数据与可用于识别个人的信息分开存储，并保证在后续的个人信息处理中不重新识别个人。加密或脱敏后的信息将无法识别特定儿童的身份， 在不泄露儿童个人信息的前提下，我们有权对脱敏化处理后的用户数据库进行挖掘、分析和利用（包括商业性使用）。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "若我们对于儿童的个人信息用于除政策列明之外的目的、范围或与使用于数据收集不一致的传输方式时，我们将会通知监护人并取得监护人的同意。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("4. 征得授权同意的例外")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "以下情形中，我们收集、使用个人信息不必征得儿童及监护人的授权同意："
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("（a) 与个人信息控制者履行法律法规规定的义务相关的；")]),
      _vm._v(" "),
      _c("p", [_vm._v("（b）与国家安全、国防安全直接相关的；")]),
      _vm._v(" "),
      _c("p", [_vm._v("（c）与公共安全、公共卫生、重大公共利益直接相关的；")]),
      _vm._v(" "),
      _c("p", [_vm._v("（d）与刑事侦查、起诉、审判和判决执行等直接相关的；")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "（d）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("（f）所收集的个人信息是您自行向社会公众公开的；")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "（g）从合法公开披露的信息中收集个人信息的，如：合法的新闻报道、政府信息公开等渠道；"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("（h）根据您的要求签订和履行合同所必需的；")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "（i）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现或处置产品或服务的故障；"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "5. 我们服务中的部分功能可能需要儿童在设备中开启特定的访问权限（例如麦克风），以实现所涉及信息的收集和使用。当儿童和监护人需要关闭该功能时，大多数移动设备都会支持该项需求，具体方法请参考或联系设备的服务商或生产商。 当设备被开启权限即代表监护人授权我们可以收集和使用相关信息来为儿童提供对应的服务，一旦设备关闭权限即代表监护人取消了授权，我们将不再基于对应的权限继续收集和使用相信息，也无法为儿童提供该权限所对应的服务。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "若您拒绝开启相关权限，将无法使用对应的功能，但不影响您使用都都产品的其他学习功能，且关闭特定权限的决定不影响此前基于监护人授权所进行的信息收集及使用。"
        ),
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("二、我们如何使用 Cookie 和同类技术")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "为使儿童获得更轻松的访问体验，儿童访问都都产品及平台时，我们可能会通过采用各种技术收集和存储儿童访问都都产品的相关数据，这样可以识别儿童的身份，帮儿童省去重复输入注册信息的步骤，或者帮助判断儿童的账户安全状态。这些数据文件可能是 Cookie、clickstream、web和同类技术，儿童的浏览器或关联应用程序提供的其他本地存储（以下简称“Cookie”）。请监护人和儿童理解，我们的某些服务只能通过使用 Cookie 才可得到实现。如儿童的浏览器或浏览器附加服务允许。多数浏览器工具条中的“帮助”部分会告诉儿童怎样防止儿童的浏览器接受新的 Cookie，怎样让儿童的浏览器在儿童收到一条新 Cookie 时通知监护人和儿童或者怎样彻底关闭 Cookie。监护人和儿童可以通过改变浏览器附加程序的设置，或通过访问提供商的网页，来关闭或删除浏览器附加程序使用的 Flash Cookie 及类似数据。监护人和儿童可以修改对 Cookie 的接受程度或者拒绝都都网站的 Cookie。"
        ),
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("三、我们如何共享、转让、公开披露儿童的个人信息")]),
      _vm._v(" "),
      _c("p", [_vm._v("（一）共享")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "我们不会与除我们及我们的关联方以外的任何公司、组织和个人共享儿童的个人信息，但以下情况除外："
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("1. 事先获得监护人明确的同意或授权；")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "2. 根据法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况下对外提供；"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "3. 符合与监护人和儿童签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "4. 我们可能会将儿童的个人信息与我们的关联方共享。但我们只会共享必要的儿童个人信息，且受本隐私政策中所声明目的的约束。我们的关联方如要改变儿童个人信息的处理目的，将再次征求监护人的授权同意。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("5. 应监护人要求处理与他人的纠纷或争议；")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "6. 与授权合作伙伴共享：在法律法规允许的范围内，为维护我们的合作伙伴、您或其他都都产品用户或社会公众利益、财产或安全免遭损害， "
        ),
        _c("b", [
          _vm._v(
            "我们仅为实现本隐私政策中声明的目的与授权合同伙伴共同提供某些服务。我们可能会与合作伙伴共享儿童的某些个人信息，以提供更好的客户服务和用户体验。"
          ),
        ]),
        _vm._v(
          "我们仅会出于合法、正当、必要、特定、明确的目的共享儿童的个人信息，并且只会共享提供服务所必要的个人信息。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "我们对内部工作人员及合作伙伴设置严格的访问权限，采取“最小授权”原则，并记录访问日志以备审计。我们将审慎评估合作方使用共享信息的目的，对合作方的安全保障能力进行综合评估，我们会对合作方获取信息的软件工具开发包进行严格的安全监测，以保护数据安全， 我们的合作伙伴无权将共享的儿童个人信息用于任何其他用途。我们已与合作方签订合同明确双方的义务与责任，明确我们的合作伙伴无权将共享的个人信息用于任何其他用途。我们会要求授权合作方按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理儿童个人信息。对于无法签订合同的合作方在使用过程中对用户造成影响的，我们将承担全部责任。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("（二）转让")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "我们不会将儿童的个人信息转让给任何公司、组织和个人，但以下情况除外："
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("1. 事先获得监护人明确的同意或授权；")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "2. 根据法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "3. 符合与监护人和儿童签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "4. 在涉及合并、收购、资产转让或类似的交易时，如涉及到儿童个人信息转让，我们会要求新的持有儿童个人信息的公司、组织继续受本隐私政策的约束，否则,我们将要求该公司、组织重新向监护人征求授权同意。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("（三）公开披露")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会公开披露儿童的个人信息："
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "1. 根据监护人或儿童的需求，在监护人明确同意的披露方式下披露其所指定的个人信息。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "2. 根据法律、法规的要求、强制性的行政执法或司法要求所必须提供儿童个人信息的情况下，我们可能会依据所要求的儿童个人信息类型和披露方式公开披露儿童的个人信息。 在符合法律法规的前提下，当我们收到上述披露信息的请求时候，我们会要求接收方必须出具与之相应的法律文件，如传票或调查函。我们对所有请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门特定调查目的且有合法权利获取的数据。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "（四）共享、转让、公开披露儿童个人信息时事先征得授权同意的例外"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "以下情形中，我们共享、转让、公开披露儿童的信息无需事先征得监护人的授权同意："
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("（a)与个人信息控制者履行法律法规规定的义务相关的；")]),
      _vm._v(" "),
      _c("p", [_vm._v("（b）与国家安全、国防安全直接相关的；")]),
      _vm._v(" "),
      _c("p", [_vm._v("（c）与公共安全、公共卫生、重大公共利益直接相关的；")]),
      _vm._v(" "),
      _c("p", [_vm._v("（d）与刑事侦查、起诉、审判和判决执行等直接相关的；")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "（d）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("（f）您自行向社会公众公开的个人信息；")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "（g）从合法公开披露的信息中收集个人信息的，如：合法的新闻报道、政府信息公开等渠道。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("b", [
          _vm._v(
            "根据法律规定，共享、转让、披露经匿名化处理的个人信息，且确保数据接收方无法复原并重新识别信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将 无需另行向监护人通知并征得监护人同意。"
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("（五）授权委托处理")]),
      _vm._v(" "),
      _c("p", [_vm._v("我们的授权合作伙伴包括以下类型：")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "（1）商品或技术服务的供应商。我们可能会将您的个人信息共享给支持我们功能的第三方。这些支持包括为我们提供支付服务、数据处理等。我们共享这些信息的目的是可以实现我们产品与/或服务的核心功能；"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "（2）第三方商家。我们必须将您为实现操作目的之必要信息委托给第三方商家，并促使其可以完成后续服务，在涉及实物商品邮寄时将您的必要地址及个人信息提供给第三方物流商家，第三方物流商家在我们的监督下提供邮寄服务，个人信息的控制权归属仍为我们。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("（六）第三方SDK接入")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "为保障都都产品的安全稳定运行，我们可能会接入由第三方提供的软件开发包（SDK）实现相关目的。我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。接入的相关第三方SDK列表可通过《用户个人信息保护政策》查看。"
        ),
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("四、我们如何保护和保存儿童的个人信息")]),
      _vm._v(" "),
      _c("p", [_vm._v("（一）我们保护您个人信息的技术与措施")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "1. 我们已使用符合业界标准的安全防护措施保护儿童提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护儿童的个人信息。我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问儿童个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护儿童个人信息重要性的认识。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "2. SSL（Secure Socket Layer）协议加密保护。当儿童从设备或浏览器向我们的服务器发送或 收取信息时，我们确保使用安全套接层（SSL）和其他算法对其进行加密。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "3. 我们会采取合理可行的措施，尽力避免收集和处理无关的儿童个人信息。我们会以“最小化”原则收集、使用、存储和传输用户信息，并通过用户协议和隐私政策告知您相关信息的使用目的和范围。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "4. 儿童的个人信息全都被储存在安全的服务器上，并在受控设施中受到保护。我们依据重要性和敏感性对您的数据进行分类，并且保证儿童的个人信息具有最高的安全等级。 "
        ),
        _c("b", [
          _vm._v(
            "我们以最小授权为原则，仅允许有必要知晓这些信息的员工、合作伙伴访问儿童个人信息，并为此设置了严格的访问权限控制和监控机制。"
          ),
        ]),
        _vm._v(
          "我们保证通过访问这些信息来帮助向儿童提供产品和服务的员工和第三方服务供应商具有严格的合同保密义务，如果未能履行这些义务，其将会受到纪律处分或被终止合作。同样，我们对以云为基础的数据存储设有专门的访问控制措施。总而言之，我们定期审查信息收集、储存和处理实践，包括物理安全措施，以防止任何未经授权的访问和使用。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("b", [
          _vm._v(
            "尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请理解，由于技术的限制以及可能存在的各种 恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保儿童提供给我们的个人信息的安全性。您知悉并理解，儿童接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题"
          ),
        ]),
        _vm._v(
          "。因此，我们强烈建议监护人和儿童采取积极措施保护儿童个人信息的安全，包括但不限于使用代号昵称、非真实生日年月、不将自己的账号等儿童个人信息透露给他人。我们将对于儿童个人数据的泄露，及时通知相关的监管机构，并在一些特别的环境下，通知数据主体相关的数据泄露事件，以满足适用的相关法律，包括监护人和儿童所在地的数据保护法规。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "我们不对有可能进入第三方网站的隐私政策的合法性负责，监护人和儿童应检查第三方网站的隐私政策并确定是否接受。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "5. 在不幸发生儿童个人信息安全事件后，我们将按照法律法规的要求【并最迟不迟于 15 个自然日内】向监护人和儿童告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、监护人和儿童可自主防范或降低风险的建议、补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知监护人和儿童，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报儿童个人信息安全事件的处置情况。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "我们制定了专门的儿童个人信息安全事件应急预案 。发生泄露等安全事件时，我们将立即启动应急机制，采取补救措施，通知监护人，并依法向网信办等监管部门报告 。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("（二）我们如何保存儿童的个人信息")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "1. 保存期限：我们只会在达成本政策所述目的所需的期限内保留儿童的个人信息，除非法律有强制的留存要求，我们判断个人信息的存储期限主要参考以下标准并以其中较长者为准："
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "a.完成与您相关的交易目的、维护相应交易及业务记录，以应对您可能的查询或投诉；"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("b.保证我们为您提供服务的安全和质量；")]),
      _vm._v(" "),
      _c("p", [_vm._v("c.您是否同意更长的留存期间；")]),
      _vm._v(" "),
      _c("p", [_vm._v("d.是否存在保留期限的其他特别约定。")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "我们将明确告知信息存储的最短必要期限，仅在实现本政策所诉目的所必需的时间内保留儿童个人信息。 在超出保留期间后，我们会根据适用法律的要求对儿童个人信息进行删除或匿名化处理。"
        ),
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("五、监护人和儿童的权利")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "监护人和儿童可以通过都都应用程序查看、访问我们收集的关于儿童的个人信息，要求修改、删除或拒绝允许进一步收集或使用这些信息，但删除这些信息的请求可能会限制儿童访问所有或部分服务。按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障监护人和儿童对儿童个人信息行使以下权利："
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("1. 访问和查询权")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "监护人和儿童有权访问和查询儿童的个人信息，法律法规规定的例外情况除外。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("如果您想行使数据访问和查询权，可以通过以下方式自行访问查询："),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "账户信息：如果监护人和儿童希望访问或编辑账户中的儿童个人资料信息或关闭账户等，您可以直接在我们产品内通过访问【家长系统】-【用户存档】页面执行此类操作。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("2. 更正权")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "当您发现我们处理的关于您的个人信息有错误时，您可以直接在我们产品内通过访问【家长系统】-【用户存档】页面直接编辑或更正您的资料信息，包括且不限于修改账号密码、更换绑定的手机号、修改昵称、更换使用等级等。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("3. 删除权")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "如您希望删除您和/或您孩子的个人信息，您可以通过本政策文末提供的联系方式联系我们，我们将在核实您的身份后及时响应您的请求。您在此同意，若我们响应并完成您的删除请求，您和/或您孩子的个人信息将在15个工作日内被删除。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("在以下情形中，监护人和儿童可以向我们提出删除个人信息的要求："),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("（1）如果我们处理儿童个人信息的行为违反法律法规；")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("（2）如果我们收集、使用儿童的个人信息，却未征得监护人的同意；"),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("（3）如果我们处理儿童个人信息的行为违反了约定；")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("（4）如果儿童不再使用我们的产品或服务，或注销了账号；"),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("（5）如果我们不再为儿童提供产品或服务；")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "（6）若我们决定响应监护人和儿童的删除请求，我们还将同时通知从我们获得儿童的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得监护人的独立授权。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "当儿童被从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("4. 撤回同意权")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "监护人可以直接通过以下方式撤回收集、使用个人信息的同意授权。撤回同意后，我们后续不会再处理您的个人信息。在我们对外共享、转让、公开披露您的个人信息时，我们会向您提供撤回同意的通知。 撤回同意不影响撤回前基于同意的您的个人信息处理。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "（a）对于可收集儿童信息的权限（麦克风），在隐私政策中提供收集系统层面的撤回授权方法（设置-应用-权限管理）；"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("5. 注销权")]),
      _vm._v(" "),
      _c("p", [_vm._v("当监护人要求注销账户时，您可以通过以下方式：")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "a． 监护人可以打开都都产品 App 进入家长模式-我的账号-设置齿轮，点击“注销帐号”进行在线注销帐号服务，注销操作提示完成时您的个人信息及账号也立即注销。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "b．通过文末的联系方式，联系官方客服说明注销需求，我们将15个工作日内响应您的需求并删除相关个人信息。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "注销帐号之后，我们将停止为您提供产品或服务，并依据监护人和儿童的要求，完全删除或匿名化身份信息，法律法规另有规定的除外。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("6. 公开与分享")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "我们的服务内不提供可让儿童与所有使用该服务的用户公开分享其相关信息， 如监护人和儿童将信息通过第三方公众领域公开或共享，由此造成的信息泄露，我们不承担责任。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("7. 获取个人信息副本")]),
      _vm._v(" "),
      _c("p", [_vm._v("监护人可通过以下路径获取个人信息副本：")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "如果您需要孩子档案及学习记录的副本，您可以通过本政策第11条提供的联系方式联系我们，我们将在核实您的身份后及时响应您的请求。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("8. 响应上述请求")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "如果您无法通过上述方式访问、更正或删除您的个人信息，或您需要访问、更正或删除您在使用我们产品与/或服务时所产生的其他个人信息，或您认为都都产品存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您均可以通过本协议下方的方式与我们联系。为了保障安全，我们可能需要您提供书面请求，或以其他方式证明您的身份，我们将在收到您反馈并验证您的身份后的 15 天内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("在以下情形中，按照法律法规要求，我们将无法响应您的请求："),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("（1）与个人信息控制者履行法律法规规定的义务相关的；")]),
      _vm._v(" "),
      _c("p", [_vm._v("（2）与国家安全、国防安全有关的；")]),
      _vm._v(" "),
      _c("p", [_vm._v("（3）与公共安全、公共卫生、重大公共利益有关的；")]),
      _vm._v(" "),
      _c("p", [_vm._v("（4）与刑事侦查、起诉和审判等有关的；")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "（5）个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "（6）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "（7）响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("（8）涉及商业秘密的。")]),
      _vm._v(" "),
      _c("h2", [_vm._v("六、我们如何存储儿童的个人信息")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "我们在中华人民共和国境内运营中收集和产生的儿童个人信息，存储在中国境内，我们不会将您的个人信息转移至境外。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "除非法律法规另有要求，我们将依据本协议第4条内容处理儿童个人信息，个人信息的存储时间将处于实现您授权使用的目的所必需的最短时间，且在超出期限后，我们将根据适用法律的要求删除或匿名化处理儿童个人信息。"
        ),
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("七、本隐私政策如何更新")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "我们的隐私政策可能变更。本政策为《软件许可及服务协议》、《个人信息保护政策》的重要组成部分。我们保留不时更新或修改本政策的权利。如果该等修改造成儿童在本政策下权利的实质减少（即“重大变更”），我们会通过不同渠道向监护人和儿童发送变更通知，包括但不限于网站公示、私信通知等方式。若监护人不同意修改后的隐私政策，有权并应立即停止使用都都产品的服务。如果儿童仍继续使用我们的服务，则视为监护人已经充分阅读、理解并接受我们对本政策相关条款所做的修改。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("本政策所指的重大变更包括但不限于：")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "1. 我们的服务模式发生重大变化。如处理儿童个人信息的目的、处理的儿童个人信息类型、儿童个人信息的使用方式等；"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "2. 我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("3. 儿童个人信息共享、转让或公开披露的主要对象发生变化；"),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "4. 监护人和儿童参与个人信息处理方面的权利及其行使方式发生重大变化；"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "5. 我们负责处理儿童个人信息安全的责任部门、联络方式及投诉渠道发生变化；"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("6. 儿童个人信息安全影响评估报告表明存在高风险时；")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("7. 我们还会将本政策的旧版本存档，供监护人和儿童查阅。"),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "在我们停止服务时，我们会及时停止继续收集儿童个人信息，可能以注意送达或网站公告的形式通知监护人和儿童停止运营的情况，并在完成账户注销后的15个工作日内，完全删除或匿名化身份信息。"
        ),
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("八、争议解决")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "本用户协议及监护人和儿童与我们的关系适用于中华人民共和国大陆地区法律，但不包括其冲突法规范。监护人和我们同意服从深圳埃努码信息技术有限公司所在地法院的司法管辖。"
        ),
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("九、如何联系我们")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "我们已设立专门的儿童个人信息保护岗位/机构，并指定专人负责相关保护工作.如果您对本隐私政策有任何疑问，或对于您的个人信息处理存在任何投诉、意见，请通过以下方式与专人联络："
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("（1）拨打客服电话：（86+）18810316494")]),
      _vm._v(" "),
      _c("p", [_c("b", [_vm._v("（2）联系官方微信：TodoServer01")])]),
      _vm._v(" "),
      _c("p", [
        _c("b", [
          _vm._v("（3）通过官方微信公众号都都思维都都GO，在线咨询人工客服"),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [_c("b", [_vm._v("（4）发送邮件至215032956@qq.com。")])]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "我们将在15个工作日内处理并答复您的投诉与意见。如无法响应您的请求，我们会在法律规定的最大时限要求内，向您发送通知并解释原因。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "如您对我们的回复不满意，或我们对您和/或您孩子个人信息的处理方式侵害了您和/或您孩子的合法权益，且在您向我们反馈后我们无法提供让您满意的回复且拒绝改进的，您可以向相关监管机构进行投诉和举报，还可以向消费者权益保护部门投诉或者向有管辖权的法院提诉讼。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("b", [
          _vm._v(
            "开发者/运营者名称：深圳埃努码信息技术有限公司（应用发布者）、北京埃努码信息技术有限公司"
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("b", [_vm._v("联系地址：北京市朝阳区望京街道福码大厦B座17层")]),
      ]),
      _vm._v(" "),
      _c("p", [_c("b", [_vm._v("联系电话：18810316494")])]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }